export const environment = {
  production: false,
  firebase: {
    projectId: "cradle-rewards",
    appId: "1:200012420340:web:7f55d4529bf658f2507aa1",
    storageBucket: "cradle-rewards.firebasestorage.app",
    apiKey: "AIzaSyBeAxeos4jTogYSdP1vDOicS-edrFzBHF4",
    authDomain: "cradle-rewards.firebaseapp.com",
    messagingSenderId: "200012420340",
    measurementId: "G-L5H52362C8",
    projectNumber: "200012420340",
    version: "2"
  },
  urlApi: 'https://hitcp010el.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  // urlApi: 'http://192.168.168.128:8201/api/v1',
  /** Google Maps JS API (mapa de ubicación + Places). Llave restringida por referrer HTTP; vacía = aviso en el mapa. */
  googleMapsApiKey: 'AIzaSyCC8UKfo-RqhsknKRAdupqVjVI7ZVTyhC4',
  /** Map ID para AdvancedMarkerElement (DEMO_MAP_ID sirve para desarrollo; crea uno propio en Google Cloud). */
  googleMapsMapId: 'DEMO_MAP_ID',
  copomex: {
    urlApi: 'https://svfe6rn4f1.execute-api.us-east-1.amazonaws.com/dev/api/v1',
    token: ''
  }
};
